import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Import components
import Dashboard from './components/Dashboard';
import DNSLogs from './components/DNSLogs';
import AIServices from './components/AIServices';
import Analytics from './components/Analytics';
import Alerts from './components/Alerts';
import Layout from './components/Layout';
import Settings from './components/Settings';

// Create theme - ShadeSec inspired colors
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9FD7D0', // Mint/teal color from ShadeSec
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9FD7D0', // Using the same teal color for secondary
      contrastText: '#ffffff',
    },
    background: {
      default: '#3B4859', // Dark slate blue from ShadeSec header/footer
      paper: '#475366', // Slightly lighter version of the background
    },
    text: {
      primary: '#ffffff',
      secondary: '#9FD7D0',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 400,
      color: '#9FD7D0',
    },
    h6: {
      fontWeight: 400,
      color: '#9FD7D0',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#9FD7D0',
          color: '#3B4859',
          '&:hover': {
            backgroundColor: '#7fbdb5',
          },
        },
        outlined: {
          borderColor: '#9FD7D0',
          color: '#9FD7D0',
          '&:hover': {
            borderColor: '#7fbdb5',
            backgroundColor: 'rgba(159, 215, 208, 0.1)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#3B4859',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#3B4859',
        },
      },
    },
  },
});

function App() {
  const [selectedCompany, setSelectedCompany] = useState('Acme Corp');
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dns-logs" element={<DNSLogs />} />
            <Route path="/ai-services" element={<AIServices />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;